export default __webpack_public_path__ + "b2e329cf622e28d81aebb1ea0c638250.png";